// import _ from 'lodash/fp'
// import GraniteError from 'granite-admin/utils/granite-error';

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
class UserPreference {
  constructor({
    pk,
    preference_key,
    preference_id,
    value,
    ...data
  }) {
    this.pk = pk;
    this.preferenceKey = String(preference_key).toLowerCase();
    this.name = preference_key;
    this.label = preference_key.replace('_', ' ').capitalize();
    this.preferenceID = preference_id;
    this.value = value;
  }
}
export default UserPreference;